export function LoadingSpinner(props) {
  return (
    <div className="text-center">
      <img src="/images/loading-spinner.gif" alt="Loading ..." />
    </div>
  );
}
